import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SppdashboardService } from 'src/app/view/dashboard/sppdashboard.service';
import { MatTableDataSource } from '@angular/material/table';
import {
faGlobe,faShieldCheck,faArrowTrendUp
} from '@fortawesome/pro-regular-svg-icons';

interface MctPath {
  role: string;
  action: string;
  ariaLabel?: string;
  linkText: string;
  linkUrl: string;
  targetTab: number;
}

@Component({
  selector: 'app-prelogin',
  templateUrl: './prelogin.component.html',
  standalone: false,
  styleUrl: './prelogin.component.scss'
})
export class PreloginComponent {

  displayedColumns: string[] = ['role', 'action', 'getStarted'];
  statusCheckInterval: any;
  

 constructor(private router: Router,private sppdashboardService: SppdashboardService){}


  ngOnInit(){
    //localStorage.setItem('prelogin','true');

    this.statusCheckInterval = setInterval(() => {
      this.sppdashboardService.getUser().subscribe((response: any) => {

    }, (error:any) => {
      if(error.status === 401){
         this.router.navigate(['/authcheck']);
      }
  })
},900000);



  }

//   onRenewal(){
//     window.open('https://learn.microsoft.com/en-us/credentials/certifications/mct-certification#renewal-and-reinstatement', '_blank');
//   }

//   onClick(){
//     this.router.navigate(['/authcheck']);
//     //window.location.reload();
//   }

featureCards = [
    {
      category: 'RENEWAL',
      title: 'Renew Your MCT Status',
      text: 'If you are an active MCT and your membership is up for renewal, you can renew your status up to 90 days in advance.',
      linkText: 'Renew your status',
      link:()=>this.onEnroll(),
      icon: '../../../assets/icons/Training.png'
    },
    {
      category: 'MCT Program',
      title: 'Become an MCT or Alumni',
      text: 'Join our prestigious community of tech professionals, enjoy exclusive benefits, and share your expertise with the world.',
      linkText: 'Become an MCT',
      link:()=>this.scrollToDiscoverSection(),
      icon: '../../../assets/icons/CertifiedProfessional.png',
      
    },
    {
      category: 'BENEFITS ACCESS',
      title: 'Sign in to the MCT Portal',
      text: 'Access the MCT Portal to view your certificate, access your program benefits and more!',
      linkText: 'Sign in',
       link:()=>this.onEnroll(),
      icon: '../../../assets/icons/House.png'
    }
  ];

  icons={
  faGlobe,
  faShieldCheck,
  faArrowTrendUp
 };



//Benefit highlights section
  icons1 = [
    {
      title: 'Global Recognition',
      text: 'Join thousands of certified trainers worldwide delivering official Microsoft training.',
      icon: this.icons.faGlobe
    },
    {
      title: 'Industry-Leading Standards',
      text: 'Learn Microsoft-proven instructional methodology and teaching best practices.',
      icon: this.icons.faShieldCheck
    },
    {
      title: 'Career Growth',
      text: 'Expand your professional opportunities and credibility as a Microsoft expert.',
      icon: this.icons.faArrowTrendUp
    }
  ];

  // Logic table for "Discover your path"
  // pathRows = [
  //   { 
  //     situation: 'Technical trainer, MCT active within last 3 years', 
  //     path: 'Test-Out Eligible', 
  //     requirement: 'Pass assessment to regain MCT status' 
  //   },
  //   { 
  //     situation: 'End-user/business trainer (any recency)', 
  //     path: 'Train the Trainer Required', 
  //     requirement: 'Complete full training program' 
  //   },
  //   { 
  //     situation: 'MCT expired more than 3 years ago', 
  //     path: 'Train the Trainer Required', 
  //     requirement: 'Reinstatement not available after 3 years' 
  //   },
  //   { 
  //     situation: 'Never been an MCT', 
  //     path: 'Train the Trainer Required', 
  //     requirement: 'Complete full training program' 
  //   }
  // ];


  dataSource = new MatTableDataSource<MctPath>([
    {
      role: 'Prospective MCT',
      action: 'Register for the 3-day MCT Onboarding Experience',
      linkText: 'Register for the MCT Onboarding Experience',
      linkUrl: '#',
      targetTab: 0
    },
     {
      role: 'Former MCT, last active 3+ years ago',
      action: 'Register for the 3-day MCT Onboarding Experience',
      linkText: 'Register for the MCT Onboarding Experience',
      linkUrl: '#',
      targetTab: 0
    },
    {
      role: 'College or university professor working for a registered TSP',
      action: 'Test-out of the Onboarding Experience through the MCT Instructional Skills Assessment',
      linkText: 'Book the MCT Instructional Skills Assessment',
      linkUrl: '#',
      targetTab: 1
    },
    {
      role: 'Former MCT (active in the last 3 years)',
      action: 'Test-out of the Onboarding Experience through the MCT Instructional Skills Assessment',
      linkText: 'Book the MCT Instructional Skills Assessment',
      linkUrl: '#',
      targetTab: 1
    },
    {
      role: 'Prospective MCT with ISC Certificate',
      action: 'Register and pay the program fees',
      ariaLabel: "Register for the MCT program for Prospective MCT with ISC Certificate",
      linkText: 'Register for the MCT program',
      linkUrl: '#',
      targetTab: 2
    },
    {
      role: 'Microsoft FTE',
      action: 'Meet Microsoft FTE requirements as described <a href="https://aka.ms/MCT4FTE" target="_blank" rel="noopener noreferrer">here</a>',
      ariaLabel: "Register for the MCT program for Microsoft FTE",
      linkText: 'Register for the MCT program',
      linkUrl: '#',
      targetTab: 3
    }
  ]);

  
scrollToDiscoverSection(): void {
    const targetElement = document.getElementById('discoverPathSection');
    
    if (targetElement) {
      // Execute standard smooth behavior scroll animations safely
      targetElement.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start', 
        inline: 'nearest' 
      });
    } else {
      console.warn('Target section container element could not be found in the DOM.');
    }
  }


  // onPurchaseTestOut() {
  //   console.log('Redirecting to Test-Out payment...');
  //   // Add logic: this.router.navigate(['/payment/test-out']);
  // }

  onEnroll() {
     this.router.navigate(['/authcheck'],{ state: { incomingFromApp: true } });
    // Add logic: this.router.navigate(['/enrollment/ttt']);
  }

  onMCT(){
    //this.router.navigate(['/find-your-fee']);
  }

  onLearnMore() {
    //this.router.navigate(['/find-your-fee']);
    window.open('https://learn.microsoft.com/en-us/credentials/certifications/mct-certification', '_blank');
  }

  onViewFaq() {
    console.log('Opening FAQ modal or page...');
  }

   ngOnDestroy(): void {
    // Clear the interval when component is destroyed
    if (this.statusCheckInterval) {
      clearInterval(this.statusCheckInterval);
    }
  }

}
